module.exports = __webpack_public_path__ + "img/Jardinage.36a1997.jpg";